/** Finds the exact test referenced from the course content tree.
 * The saved `bloque` of legacy references may be the content tab instead of
 * the test-bank block, so an exact title match is allowed across all blocks.
 */
export function findLinkedTestTopic(estructura, temaName, preferredBlock = "") {
  const blocks = Array.isArray(estructura) ? estructura : [];
  const targetName = typeof temaName === "string" ? temaName.trim() : "";
  const blockName = typeof preferredBlock === "string" ? preferredBlock.trim() : "";
  if (!targetName) return null;

  const ordered = [
    ...blocks.filter((block) => blockName && String(block?.nombre) === blockName),
    ...blocks.filter((block) => !blockName || String(block?.nombre) !== blockName),
  ];
  for (const block of ordered) {
    const topic = (Array.isArray(block?.temas) ? block.temas : []).find(
      (entry) => String(entry?.nombre ?? "").trim() === targetName,
    );
    if (topic) return { block, topic };
  }
  return null;
}
